export enum ComponentModes {
  create = 'create',
  edit = 'edit',
  view = 'view',
  add = 'add',
}
